__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/94c47f61460fb889fd6629ee1556aa030095b01d9317f85afc92650a/";